import React from "react";
import * as AmplitudeBrowser from "@amplitude/analytics-browser";
import { withRouter } from "react-router-dom";

import buildAmplitudePageVisitEventData from "../../../../../lib/analytics/buildAmplitudePageVisitEventData";

@withRouter
class AmplitudePageViewHandler extends React.Component {
  componentDidMount() {
    const { location, match } = this.props;

    this.trackPageView(location, match);
  }

  componentDidUpdate(
    prevProps: Readonly<P>,
    prevState: Readonly<S>,
    snapshot: SS
  ) {
    const { location: prevLocation } = prevProps;
    const { location, match } = this.props;

    if (prevLocation.pathname !== location.pathname) {
      this.trackPageView(location, match);
    }
  }

  trackPageView(location) {
    const eventData = buildAmplitudePageVisitEventData(
      location.pathname,
      window.location.href
    );

    if (!eventData) {
      return;
    }

    AmplitudeBrowser.track("page_visit", eventData);
  }

  render() {
    return null;
  }
}

export default AmplitudePageViewHandler;
